import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as CustomPropTypes from 'lib/CustomPropTypes';

import LeadBorderTop from 'components/LeadBorderTop';
import TeaseCard from 'components/TeaseCard';
import TeasePicture from 'components/TeasePicture';
import FeaturedTease from 'components/packages/ThreeFeaturedPlusList/FeaturedTease';
import SidebarTease from 'components/packages/ThreeFeaturedPlusList/SidebarTease';
import AIMS_FLAVORS from 'lib/aimsFlavors';

// TODO: [BENTO-12233] Handle grid styling with the new theming system
// Temporarily leaving this stylesheet to handle grid only styles
// until different solution for grid is implemented within new theming strategy
import teaseStyles from './teaseStyles.module.scss';

const defaultMetadata = {
  showAuthor: false,
  showFeaturedAuthor: false,
  showTimestamp: false,
};

class ThreeFeaturedPlusList extends Component {
  static propTypes = {
    content: CustomPropTypes.package.isRequired,
    pkgClassName: PropTypes.string,
    vertical: PropTypes.string.isRequired,
  };

  static defaultProps = {
    pkgClassName: 'pkg threeFeaturedPlusList',
  };

  getTeaseCard(teaseContent) {
    const {
      content: {
        metadata: packageMetadata = {},
      },
    } = this.props;

    const metadata = {
      ...defaultMetadata,
      ...packageMetadata,
    };

    return (
      <TeaseCard
        content={teaseContent}
        styles={teaseStyles}
        {...metadata}
      >
        <TeasePicture
          responsiveFlavors={{
            s: AIMS_FLAVORS.FOCAL_758x379,
            m: AIMS_FLAVORS.FOCAL_460x460,
            l: AIMS_FLAVORS.FOCAL_276x276,
            xl: AIMS_FLAVORS.FOCAL_348x348,
          }}
          type={teaseContent.type}
          computedValues={teaseContent.computedValues}
          placeholder
        />
      </TeaseCard>
    );
  }

  getSidebarItem = (item) => {
    const { vertical } = this.props;
    const classes = classNames(
      'three-featured-plus-list__sidebar-item',
      {
        'three-featured-plus-list__sidebar-item-sponsored': item.item && item.item.nativeAd,
      },
    );

    return (
      <li className={classes} key={item.id} data-contentid={item.id}>
        <SidebarTease content={item} vertical={vertical} />
      </li>
    );
  };

  secondaryContent = (item, id) => {
    const adStyle = item.type === 'ad' ? 'boxinlineAd' : '';
    return (
      <div className={classNames('grid-fr-half-m', 'three-featured-plus-list__secondary-article', adStyle)} key={id}>
        { this.getTeaseCard(item) }
      </div>
    );
  };

  sidebarItems() {
    const { content: { items } } = this.props;

    const hasAd = items.some((i) => i.type === 'ad');

    if (hasAd) {
      return items.slice(4).map(this.getSidebarItem);
    }

    return items.slice(3, 8).map(this.getSidebarItem);
  }

  sidebarTitle() {
    const { content: { metadata = {} } } = this.props;

    return (
      <h2 className="three-featured-plus-list__sidebar-title">
        <span className="three-featured-plus-list__sidebar-vertical-name">
          {metadata.listTitlePrimary}
        </span>
        <span>{metadata.listTitleSecondary}</span>
      </h2>
    );
  }

  sidebarSubtitle() {
    const { content: { metadata = {} } } = this.props;

    if (!metadata.listSubtitle) {
      return null;
    }

    return (
      <h2 className="three-featured-plus-list__sidebar-subtitle">
        {metadata.listSubtitle}
      </h2>
    );
  }

  sidebarDescription() {
    const { content: { metadata = {} } } = this.props;

    if (!metadata.listDescription) {
      return null;
    }

    return (
      <div className="three-featured-plus-list__sidebar-dek">
        { metadata.listDescription }
      </div>
    );
  }

  render() {
    const {
      content: {
        id, items, metadata: packageMetadata = {}, packageIndex,
      } = {},
      pkgClassName,
    } = this.props;

    const hasAd = items.some((i) => i && i.type === 'ad');

    const firstContentItem = items[0];
    const secondaryContentItems = hasAd ? items.slice(1, 4) : items.slice(1, 3);

    return !items.includes(null) && (
      <section
        data-packageid={id}
        className={classNames(
          pkgClassName,
          `pkg-index-${packageIndex}`,
          'three-featured-plus-list',
        )}
        data-test="three-featured-plus-list__section"
      >
        <LeadBorderTop types={['collectionLead']} />
        <div className="layout-grid-container items-start">
          <div className="three-featured-plus-list__articles">
            <FeaturedTease
              content={firstContentItem}

              // default is true
              showAuthor

              // default is true for non-custom tease
              showDek={firstContentItem.type !== 'custom'}

              {...packageMetadata}
              {...firstContentItem.metadata}
            />

            <div className="three-featured-plus-list__secondary-articles">
              { secondaryContentItems.map(this.secondaryContent) }
            </div>
          </div>

          <section className="three-featured-plus-list__sidebar">
            <div className="three-featured-plus-list__sidebar-content">
              { this.sidebarTitle() }

              <div className="three-featured-plus-list__sidebar-info">
                { this.sidebarSubtitle() }
                { this.sidebarDescription() }
              </div>

              <ul className="three-featured-plus-list__sidebar-items">
                { this.sidebarItems() }
              </ul>
            </div>
          </section>
        </div>
      </section>
    );
  }
}

export default ThreeFeaturedPlusList;
